import * as NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import router from '../router';
import { Route } from 'vue-router';

// NProgress configuration: https://www.npmjs.com/package/nprogress

router.beforeEach((to: Route, from: Route, next: Function) => {
    // If this isn't an initial page load.
    if (to.name && to.name !== "root") {
        // Start the route progress bar.
        NProgress.start();
    }
    next();
});
router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done();
});


